"use client";
import React, { useEffect } from "react";
import Image from "next/image";
import "./index.scss";

import { useBrandLogo } from "@/api/about/use-query";
import { TBrandLogoResponse } from "@/typings/about";

const MediaPartner: React.FC = () => {
  const { mutate: fetchBrandLogo, data: brandLogos } = useBrandLogo();

  useEffect(() => {
    fetchBrandLogo();
  }, [fetchBrandLogo]);

  return (
    <div className="yf-about-us-media-partner">
      <h2 className="text-[42px] font-semibold">Collaboration Brands</h2>
      <div className="flex justify-center items-center gap-4 mt-4">
        {(brandLogos?.data.slice(0, 8) || []).map(
          (item: TBrandLogoResponse) => (
            <div className="about-us-media-partner-box" key={item.logo}>
              <Image
                src={item.logo}
                alt={item.brand_name}
                title={item.brand_name}
                width={50}
                height={50}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MediaPartner;
